<template>
  <section class="section columns">
    <div class="container column box">
      <h2 class="title">{{studentName}} - {{document.name}}</h2>
      <div class="box" v-html="document.content"></div>
      <div class="has-text-left">
        <div class="modal" ref="deleteComment">
          <div class="modal-background" @click.prevent="hideDeleteModal"></div>
          <div class="modal-content section box">
            <div
              class="has-text is-size-3 delete-text has-text-centered"
            >Are you sure you would like to delete?</div>
            <div class="field is-grouped delete-buttons">
              <div class="control">
                <button class="button is-link" @click.prevent="hideDeleteModal">Cancel</button>
              </div>
              <div class="control">
                <button
                  class="button is-text"
                  @click.prevent="deleteComment(commentToDelete)"
                >Confirm</button>
              </div>
            </div>
          </div>
          <button @click.prevent="hideDeleteModal" class="modal-close is-large" aria-label="close"></button>
        </div>
        <div v-for="(comment, l) in document.comments" :key="l" class="box comment">
          <article class="media">
            <div class="media-left">
              <figure class="image is-64x64">
                <img :src="comment.creator.profile_image" alt="Image">
              </figure>
            </div>
            <div class="media-content level">
              <div class="content level-left">
                <p>
                  <strong>{{comment.creator.full_name}}</strong>
                  <small>{{dateFormat(comment.created_at.date)}}</small>
                  <br>
                  {{commentContent(comment.body)}}
                </p>
              </div>
              <div class="level-right">
                <button
                  v-if="$store.state.auth.user.is_admin || $store.state.auth.user.id == comment.creator.id"
                  class="button delete-button"
                  @click.prevent="showDeleteModal(comment.id)"
                >Delete</button>
              </div>
            </div>
          </article>
        </div>
        <div class="wrapper">
          <button
            @click.stop="openEmoji"
            :class="{ 'is-danger': wrongInput}"
            class="button emojiButton"
            id="test"
          >😃</button>

          <textarea
            class="textarea commentArea"
            v-model="input"
            :class="{ 'is-danger': wrongInput}"
          ></textarea>
          <button class="button is-pulled-left" @click.prevent="submitComment">Submit Comment</button>

          <emoji-picker class="emojiPicker column is-half" :search="search">
            <div
              class
              slot="emoji-invoker"
              slot-scope="{ events: { click: clickEvent } }"
              @click.stop="clickEvent"
              ref="EmojiOpen"
            ></div>
            <div slot="emoji-picker" slot-scope="{ emojis }">
              <div class>
                <div class>
                  <input class="input" placeholder="Search..." type="text" v-model="search" v-focus>
                </div>
                <div class="emojiBox">
                  <div v-for="(emojiGroup, category) in emojis" :key="category">
                    <h5 class>{{ category }}</h5>
                    <div class>
                      <button
                        class="button"
                        v-for="(emoji, emojiName) in emojiGroup"
                        :key="emojiName"
                        @click="append(emoji)"
                        :title="emojiName"
                      >{{ emoji }}</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </emoji-picker>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { DocumentClient } from "../../clients/DocumentClient.js";
import { ForumClient } from "../../clients/ForumClient.js";

export default {
  name: "ProjectReview",
  props: ["studentName", "documentId"],
  data() {
    return {
      document: Object,
      wrongInput: false,
      input: null,
      search: ""
    };
  },
  methods: {
    deleteComment(commentId) {
      ForumClient.deleteComment(commentId)
        .then(response => {
          this.commentToDelete = "";
          this.getDocument(this.documentId);
          this.hideDeleteModal();
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitComment() {
      if (this.input) {
        let newComment = encodeURIComponent(this.input);
        DocumentClient.createDocumentComment(this.documentId, newComment)
          .then(response => {
            this.input = "";
            this.getDocument(this.documentId);
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.wrongInput = true;
        setTimeout(() => {
          this.wrongInput = false;
        }, 600);
      }
    },
    dateFormat(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric"
      };
      var today = new Date(date);
      var newDate = new Date(
        today.getTime() + today.getTimezoneOffset() * 60 * 1000
      );

      var offset = today.getTimezoneOffset() / 60;
      var hours = today.getHours();

      newDate.setHours(hours - offset);

      return " @" + newDate.toLocaleString("en-GB", options);
    },

    append(emoji) {
      this.input += emoji;
    },
    openEmoji() {
      this.$refs.EmojiOpen.click();
    },
    showDeleteModal(commentId) {
      this.commentToDelete = commentId;
      this.$refs.deleteComment.classList.add("is-active");
    },
    hideDeleteModal() {
      this.$refs.deleteComment.classList.remove("is-active");
    },
    commentContent(content) {
      return decodeURIComponent(content);
    },
    getDocument(documentId) {
      DocumentClient.getDocument(documentId)
        .then(response => {
          this.document = response.data.document;
        })
        .catch(error => console.log(error));
    }
  },
  mounted() {
    this.getDocument(this.documentId);
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus();
      }
    }
  }
};
</script>


<style lang="scss" scoped>
@import "../../assets/scss/variables";

.post-container {
  border: 2px solid $pantoneBlue;

  .comment {
    border: 1px solid $lightBlue;
  }
}

.commentArea.is-danger {
  animation: shake 0.3s;
  animation-iteration-count: 2;
}

.emoji-invoker {
  transition: all 0.2s;
}

.is64x64,
.is128x128 {
  overflow: hidden;
}
.delete-buttons {
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
}

.delete-text {
  margin-bottom: 3rem;
}

.delete-button {
  background-color: $orange;
}

.wrapper {
  position: relative;

  .emojiButton {
    position: absolute;
    right: 0.1%;
    z-index: 30;
    top: 1%;
  }

  .emojiPicker {
    float: right;

    .emojiBox {
      max-height: 163px;
      overflow-y: scroll;

      button {
        width: 35px;
        margin: 1px;
        border: 1px $lightBlue solid;
        background-color: lightblue;
      }
    }
  }
}

@keyframes shake {
  0% {
    transform: translate(0px, 0px);
  }

  25% {
    transform: translate(-3px, 0px);
  }

  50% {
    transform: translate(0px, 0px);
  }

  75% {
    transform: translate(-3px, 0px);
  }

  100% {
    transform: translate(0px, 0px);
  }
}
</style>


